import { forEach } from 'lodash-es'

class StripeForm {
  constructor(options = {}) {
    //console.log("StripeForm constructor with options:", options)
    Object.assign(
      this,
      {
        paymentErrors: [],
        stripe: null,
        formQuerySelector: '.js-subscription-form',
        submitQuerySelector: '.js-commit-button',
        paymentErrorExplanationQuerySelector: '.js-payment-error-explanation',
        paymentErrorsQuerySelector: '.js-errors-target',
      },
      options
    )
  }

  init() {
    this.storeReferences()
  }

  storeReferences() {
    this.$form = document.querySelector(this.formQuerySelector)
    this.$paymentErrorExplanation = this.$form.querySelector(this.paymentErrorExplanationQuerySelector)
  }

  updatePaymentErrors() {
    const $errorsTarget = this.$paymentErrorExplanation.querySelector(this.paymentErrorsQuerySelector)
    $errorsTarget.innerHTML = ''
    if (this.paymentErrors.length > 0) {
      const ulNode = document.createElement('ul')
      forEach(this.paymentErrors, message => {
        const liNode = document.createElement('li')
        liNode.textContent = message
        ulNode.appendChild(liNode)
      })
      $errorsTarget.append(ulNode)
      this.$paymentErrorExplanation.classList.remove('hidden')
    } else {
      this.$paymentErrorExplanation.classList.add('hidden')
    }
  }

  enableSubmit() {
    const button = this.$form.querySelector(this.submitQuerySelector)
    button.value = this.enabledSubmitButtonValue
    button.disabled = false
  }

  disableSubmit() {
    const button = this.$form.querySelector(this.submitQuerySelector)
    const disableWithText = button.dataset.disableWith || 'Please wait...'
    button.value = disableWithText
    button.disabled = true
  }
}

export default StripeForm
